const ENV = process.env.VUE_APP_ENV;
const advertCode = {
  10: {
    code: '10',
    year: 25,
    homePopupCode: 'App25001',
    bannerCode: 'App25002',
    customButtonCode: 'App25003',
    bigAdvertCode: 'App25004',
    smallAdvertCode: 'App25005',
    openLiveCode: 'App25006',
    hotSaleCourseId: ENV === 'test' || ENV === 'local' ? 296 : 271,
    postgraduateChatCode: 'App25007',
    limtiCouponCode: 'App25008',
    bottomFloatCode: 'App25009',
    showExcellentCourse:true,
  },
  12: {
    code: '12',
    year: 26,
    homePopupCode: 'App26001',
    bannerCode: 'App26002',
    customButtonCode: 'App26003',
    bigAdvertCode: 'App26004',
    smallAdvertCode: 'App26005',
    openLiveCode: 'App26006',
    hotSaleCourseId: ENV === 'test' || ENV === 'local' ? 296 : 271,
    postgraduateChatCode: 'App26007',
    limtiCouponCode: 'App26008',
    bottomFloatCode: 'App26009',
    showExcellentCourse:false,
  },
  // 13: {
  //   code: '13',
  //   year: 27,
  //   homePopupCode: 'App26001',
  //   bannerCode: 'App26002',
  //   customButtonCode: 'App26003',
  //   bigAdvertCode: 'App26004',
  //   smallAdvertCode: 'App26005',
  //   openLiveCode: 'App26006',
  //   // hotSaleCourseId: ENV === 'test' || ENV === 'local' ? 296 : 271,
  //   postgraduateChatCode: 'App26007',
  //   limtiCouponCode: 'App26008',
  //   bottomFloatCode: 'App26009',
  //   showExcellentCourse:false,
  // },
  13: {
    code: '13',
    year: 27,
    homePopupCode: 'App27001',
    bannerCode: 'App27002',
    customButtonCode: 'App27003',
    bigAdvertCode: 'App27004',
    smallAdvertCode: 'App27005',
    openLiveCode: 'App27006',
    hotSaleCourseId: ENV === 'test' || ENV === 'local' ? 471 : 471,
    postgraduateChatCode: 'App27007',
    limtiCouponCode: 'App27008',
    bottomFloatCode: 'App27009',
    showExcellentCourse:true,
  },
  15: {
    code: '15',
    year: 28,
    // homePopupCode: 'App27001',
    bannerCode: 'App28001',
    customButtonCode: 'APP28010',
    bigAdvertCode: 'App28003',
    smallAdvertCode: 'App28005',
    openLiveCode: 'pc20260116',
    // hotSaleCourseId: ENV === 'test' || ENV === 'local' ? 471 : 471,
    postgraduateChatCode: 'APP28007',
    limtiCouponCode: 'APP28008',
    bottomFloatCode: 'APP28009',
    // showExcellentCourse:true,
  },
};
export { advertCode };
